import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../Tables/BaseTableColumn";
import {FileEditorEnhance} from "../Files/FileEditorEnhance";
import {StreamBankEditableCheckerEnhance} from "../Enhancements/StreamBankEditableCheckerEnhance";

import {service as FileUploadService} from "../../../Services/FileUploadService";
import {FileVisibilityHelper} from "../Files/FileVisibilityHelper";

@StreamBankEditableCheckerEnhance
@FileEditorEnhance
export class FileTableColumn extends BaseTableColumn {
    @autobind
    reloadData() {
        const { ReloadData } = this.props.CustomData;

        if(ReloadData) {
            ReloadData();
        }
    }


    @autobind
    downloadFile(fileId) {
        const { rowData } = this.props;

        if(!rowData) {
            return;
        }

        FileUploadService.DownloadFile(rowData.fileName, rowData.fileUploadId);
    }

    @autobind
    _render() {
        const { Value, rowData } = this.props;

        if(!rowData) {
            return <span>N/A</span>;
        }

        return <div className="cell-with-spaced-content">
            <a className="link-primary" onClick={this.downloadFile} title={Value}>
                {Value}
            </a>
            <FileVisibilityHelper file={rowData} />
        </div>;
    }
}
